import { Reveal, Overline } from "./Reveal";
import { DIFFERENTIATORS } from "@/data/content";

export const Differentiators = () => (
  <section data-testid="differentiators-section" className="bg-cream-dark py-24 sm:py-32">
    <div className="mx-auto max-w-6xl px-5">
      <Reveal className="mb-14 max-w-2xl">
        <Overline>The Difference</Overline>
        <h2 className="mt-4 font-heading text-2xl font-extrabold tracking-tight text-ink sm:text-3xl lg:text-4xl">
          What Makes My Approach Different?
        </h2>
      </Reveal>
      <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {DIFFERENTIATORS.map((d, i) => (
          <Reveal key={d.title} delay={(i % 3) * 0.08}>
            <div
              data-testid={`differentiator-card-${i}`}
              className="group h-full rounded-3xl border border-peach/20 bg-white p-7 transition-[border-color,transform,box-shadow] duration-500 hover:-translate-y-1.5 hover:border-peach-dark/50 hover:shadow-[0_24px_50px_-24px_rgba(226,121,111,0.5)]"
            >
              <span className="font-display text-4xl tracking-wide text-peach-dark/50 transition-colors duration-500 group-hover:text-peach-dark">
                {String(i + 1).padStart(2, "0")}
              </span>
              <h3 className="mt-4 font-heading text-base font-bold leading-snug text-ink sm:text-lg">{d.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-ink-muted">{d.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
